import { LanguagePicker as LangPick } from '@speedlo/ui'
import { observer } from 'mobx-react-lite'
import React from 'react'

import { useRoot } from '../app/useRoot'
import { appConfig } from '../config'
import { RM } from '../tools/ramda'

interface IProps {
  className?: string
}

export const LanguagePicker = observer<IProps>(({ className }) => {
  const { business, user } = useRoot()
  if (!business.isValid) {
    return null
  }

  const appLanguages = appConfig.supportedLanguages.map(RM.toUpper)
  const branchLanguages = business.branch!.supportedLanguages
  const availableLanguages = RM.intersection(appLanguages, branchLanguages)

  return (
    <LangPick
      availableLanguages={availableLanguages}
      selectedLanguage={user.language}
      onChange={language => {
        if (language !== user.language) {
          user.selectLanguage(language)
          // TODO: Figure out way to flush model persistence
          setTimeout(() => {
            window.location.reload()
          }, 300)
        }
      }}
      className={className}
      backgroundColor="white"
      arrowColor="#5A5A5A"
    />
  )
})
